var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto",attrs:{"color":"white","width":"200px"}},[_c('v-card-text',[_vm._v(" Centered ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }